export default __webpack_public_path__ + "static/media/land.4ce64860.webp";